import { useContext, useRef, useState } from 'react';
import {
  Button,
  Box,
  VStack,
  List,
  ListItem,
  Text,
  Stack,
  useDisclosure,
  useColorModeValue,
  useOutsideClick,
  Spinner,
  Center,
  useToast,
  HStack,
} from '@chakra-ui/react';
import PassesListContext from '../../../store/client/PassesListContext';
import CustomToast from '../../../common/CustomToast';
import { CustomCsvDownloadIcon } from '../../../theme/icons/CustomCsvDownloadIcon';
import { HttpContext } from '../../../context/HttpContext';
import { MeContext } from '../../../context/MeContext';
import moment from 'moment-timezone';
import { useReportAndToastApiError } from '../../../hooks/useReportAndToastApiError';

const PassesListDownload = () => {
  const { authAxios } = useContext(HttpContext);
  const { filterValues } = useContext(PassesListContext);
  const [isDownloading, setIsDownloading] = useState(false);
  const modePickerPopupBg = useColorModeValue('white', 'primaryDark');
  const meCtx = useContext(MeContext);
  const { filterEntity } = meCtx.state;
  const toast = useToast();
  const reportAndToastApiError = useReportAndToastApiError();
  const ref = useRef();

  const prepareQueryString = (obj) => {
    let filterValues = '';
    Object.entries(obj).forEach(([key, value]) => {
      if (!key.startsWith('by') && value !== '') {
        if (key === 'extId') {
          key = 'externalId';
        } else if (key === 'id') {
          key = 'uuid';
        } else if (key === 'passTemplate') {
          key = 'passTemplateName';
        }
        filterValues = `${filterValues}&${key}=${value}`;
      }
    });

    return filterValues;
  };

  const generatePassesListData = async () => {
    const filterString = prepareQueryString(filterValues);
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const encodedEmail = encodeURIComponent(meCtx.state.account.email);

    await authAxios.get(
      filterEntity
        ? `api/v1/entities/${
            filterEntity.uuid
          }/passes?export=true${filterString}&timezone=${encodeURIComponent(
            userTimezone
          )}&email=${encodedEmail}`
        : `api/v1/passes?export=true${filterString}&timezone=${encodeURIComponent(
            userTimezone
          )}&email=${encodedEmail}`
    );

    try {
      toast({
        // duration: null,
        render: ({ onClose }) => (
          <CustomToast
            status="info"
            title="Please check your email"
            description={`A download link has been sent to ${meCtx.state.account.email}. It may take a few minutes to arrive.`}
            onClose={onClose}
          />
        ),
      });
    } catch (error) {
      setIsDownloading(false);
      reportAndToastApiError(error);
    }
  };

  return (
    <Stack
      spacing="18px"
      direction={{ base: 'column', sm: 'row' }}
      // mt={{ base: '24px', '2xl': '0' }}
      shouldWrapChildren="true"
      mt={{ base: '20px', '2xl': '0' }}
      position="relative"
      ref={ref}
    >
      <Button
        size="sm"
        px="30px"
        width={{ base: 'full', sm: '198px' }}
        onClick={() => {
          generatePassesListData();
        }}
        isLoading={isDownloading}
      >
        {isDownloading ? (
          <Center as="span" zIndex={1}>
            <Spinner
              width="15px"
              height="15px"
              thickness="2px"
              speed="0.65s"
              emptyColor="quinaryBackground"
              mx="auto"
            />
          </Center>
        ) : (
          <Box as="span" zIndex={1}>
            <CustomCsvDownloadIcon
              h="20px"
              w="auto"
              mr="10px"
              fill="white"
              mb="5px"
            />
            Download CSV
          </Box>
        )}
      </Button>
    </Stack>
  );
};

export default PassesListDownload;
